// Hero/section video controller — owns play/pause state for every
// `.sentiments-hero-video__media`. Two responsibilities per instance:
//
//  1. Pause when scrolled out of view (perf: saves CPU/battery).
//  2. Manual toggle button (UX: user opt-out).
//
// Pairs each <video> with the nearest `.sentiments-hero-video__toggle`
// sibling so the homepage hero AND any later editorial video bands
// (e.g. the Versatile band) get independent controllers.

function bindOne(video) {
	// Find a toggle scoped to the SAME section the video sits in. Walk
	// up looking for either the hero section wrapper or the section-
	// video wrapper, whichever comes first.
	const scope = video.closest('.sentiments-hero-video, .sentiments-section-video') || document;
	const toggle = scope.querySelector('.sentiments-hero-video__toggle');

	let userPaused = false;

	const syncToggle = () => {
		if (!toggle) return;
		const isPlaying = !video.paused && !video.ended;
		toggle.dataset.state = isPlaying ? 'playing' : 'paused';
		toggle.setAttribute(
			'aria-label',
			isPlaying ? 'Pause video' : 'Play video'
		);
		toggle.setAttribute('aria-pressed', String(!isPlaying));
	};

	video.addEventListener('play', syncToggle);
	video.addEventListener('pause', syncToggle);
	syncToggle();

	if (toggle) {
		toggle.addEventListener('click', () => {
			if (video.paused) {
				userPaused = false;
				video.play().catch(() => {});
			} else {
				userPaused = true;
				video.pause();
			}
		});
	}

	if (typeof IntersectionObserver === 'function') {
		const io = new IntersectionObserver(
			(entries) => {
				for (const entry of entries) {
					if (entry.isIntersecting) {
						if (!userPaused && video.paused) {
							video.play().catch(() => {});
						}
					} else if (!video.paused) {
						video.dataset.sentimentsOffscreen = '1';
						video.pause();
						delete video.dataset.sentimentsOffscreen;
					}
				}
			},
			{ threshold: 0.01 }
		);
		io.observe(video);
	}
}

export function initHeroVideo() {
	document.querySelectorAll('.sentiments-hero-video__media').forEach(bindOne);
}
